import { db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

export async function getTerm(id) {
  const termRef = doc(db, "terms", id);
  const termSnap = await getDoc(termRef);
  return { id: termSnap.id, ...termSnap.data() };
}
